import { Response } from './Response';

export class QueryResponse<TModel> extends Response {
  items: TModel[];
  totalCount: number;
  model: TModel[];
}



// WEBPACK FOOTER //
// ./src/app/core/services/QueryResponse.ts